module.exports = __webpack_public_path__ + "img/3.522de99b.png";